import { ca } from '@cian/analytics';
import {
  ITrackAnketaModalProps,
  ITrackClickButtonInModalProps,
  ITrackClickOnOfferProps,
  ITrackFieldValuesProps,
  ITrackFunctionParams,
  ITrackShowModalProps,
  ITrackShowOffers,
} from './types';

const trackEvent = (props: ITrackFunctionParams) => {
  const { extra, ...params } = props;

  ca('eventSite', {
    ec: 'mortgage_mini_calculator',
    event: 'oldevent',
    ...params,
    page: {
      extra: {
        ...(extra || {}),
      },
    },
  });
};

export const trackScrollAndStopOnBlock = () => {
  trackEvent({
    ea: 'show',
    el: 'scroll_view',
  });
};

export const trackClickOnTargetButton = () => {
  trackEvent({
    ea: 'click',
    el: 'create_mortgage_app',
  });
};

export const trackEditFieldValues = ({ el, paramInput, paramValue }: ITrackFieldValuesProps) => {
  trackEvent({
    ea: 'click',
    el,
    extra: {
      paramInput,
      paramValue: paramValue.toString(),
    },
  });
};

export const trackShowEmptyListing = () => {
  trackEvent({
    ea: 'show',
    el: 'empty_listing',
  });
};

export const trackClickEmptyListingBtn = () => {
  trackEvent({
    ea: 'click',
    el: 'empty_listing_landing_btn',
  });
};

export const trackShowErrorListing = () => {
  trackEvent({
    ea: 'show',
    el: 'error_listing',
  });
};

export const trackClickRefresh = () => {
  trackEvent({
    ea: 'click',
    el: 'error_listing_refresh',
  });
};

export const trackShowOffers = ({ offersList }: ITrackShowOffers) => {
  trackEvent({
    ea: 'show',
    el: 'offer_view',
    extra: {
      offers_list: offersList,
    },
  });
};

export const trackClickOnOffer = ({ offerParams, listNumber }: ITrackClickOnOfferProps) => {
  trackEvent({
    ea: 'click',
    el: 'main_offer',
    extra: {
      list_number: listNumber,
      offer_params: offerParams,
    },
  });
};

export const trackShowModal = ({ offer }: ITrackShowModalProps) => {
  trackEvent({
    ea: 'show',
    el: 'offer_modal',
    extra: {
      offer_params: offer,
    },
  });
};

export const trackClickOnShowPhone = ({ offer }: ITrackClickButtonInModalProps) => {
  trackEvent({
    ea: 'click',
    el: 'modal_contact_builder',
    extra: {
      offer_params: offer,
    },
  });
};

export const trackClickOnCreateMortgage = ({ offer }: ITrackClickButtonInModalProps) => {
  trackEvent({
    ea: 'click',
    el: 'modal_create_mortgage_app',
    extra: {
      offer_params: offer,
    },
  });
};

const trackAnketaModalEvent = (
  ea: ITrackFunctionParams['ea'],
  el: string,
  { offer, userInput, listNumber }: ITrackAnketaModalProps,
) => {
  trackEvent({
    ea,
    el,
    extra: {
      offer_params: offer,
      userInput,
      list_number: listNumber,
    },
  });
};

export const trackShowUnfinishedAnketaModal = (props: ITrackAnketaModalProps) => {
  trackAnketaModalEvent('show', 'modal_existing_draft_choice', props);
};

export const trackClickStartNewAnketa = (props: ITrackAnketaModalProps) => {
  trackAnketaModalEvent('click', 'modal_existing_draft_start_new', props);
};

export const trackClickContinueOldAnketa = (props: ITrackAnketaModalProps) => {
  trackAnketaModalEvent('click', 'modal_existing_draft_continue_old', props);
};

export const trackShowSubmittedAnketaModal = (props: ITrackAnketaModalProps) => {
  trackAnketaModalEvent('show', 'modal_existing_draft_success', props);
};

// TODO: События Авторизации (возможно стоит вынести отдельно)

export const trackOpenPhoneAuthModal = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'show',
    el: 'phone',
  });
};

export const trackOpenSmsAuthModal = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'show',
    el: 'sms_code',
  });
};

export const trackClickConfirmPhone = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'phone_continue',
  });
};

export const trackClickOnRepeatSms = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'phone_send_again',
  });
};

export const trackAgreeToCommercial = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'agree_on_ads',
  });
};

export const trackClickConfirmSms = () => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'sms_code_verify',
  });
};

export const trackAuthorizationSuccess = () => {
  trackEvent({
    ec: 'Authorization',
    ea: 'success',
    el: 'Auth_phone',
  });
};
